<template>
    <van-popup v-model="showPrick" position="bottom" :style="{ height: '50%' }">
        <van-picker 
            show-toolbar 
            value-key="name"
            :columns="typeList" 
            @confirm="onConfirm"
            @cancel="onCancel"
            @change="onChange"/>
            <!-- 控制默认选项 -->
            <!-- :default-index="2"   -->
    </van-popup>
</template>

<script>
export default {
    props: {
        typeList:{
            type:Array,
            default:()=>[]
        }
    },
    data () {
        return {
            showPrick: false,
        }
    },
    created () {

    },
    methods: {
        showPicker () {
            this.showPrick = true;
        },
        onConfirm(value, index) {
            this.$emit('getTypeValue', value, index);
            this.onCancel();
        },
        onChange(picker, value, index) {
            console.log(`当前值：${value}, 当前索引：${index}`);
        },
        onCancel() {
            this.showPrick = false;
        },
    }
}
</script>

<style lang="less" scoped>
.picker_wrap {

}
</style>
